import type { Components, Theme } from "@mui/material";

export const fidooTabs: Components<Theme>["MuiTabs"] = {
  defaultProps: {
    size: "large",
    styleVariant: "underline",
  },
  styleOverrides: {
    root: ({ theme }) => ({
      "& .MuiTab-root": {
        paddingTop: theme.spacing(1.9),
        paddingBottom: theme.spacing(1.9),
      },
    }),
    indicator: ({ theme }) => ({
      backgroundColor: theme.palette.custom.borderPrimary,
    }),
  },
  variants: [
    {
      props: { styleVariant: "boxed" },
      style: ({ theme }) => ({
        backgroundColor: theme.palette.custom.fillSecondary,
        borderRadius: "16px",
        padding: theme.spacing(0.5),
        "& .MuiTab-root": {
          backgroundColor: "transparent",
          borderRadius: theme.borderRadius.sm,
          paddingTop: theme.spacing(0.5),
          paddingBottom: theme.spacing(0.5),
          borderBottom: "none",
          minHeight: "40px",
          zIndex: 1,
        },
        "& .MuiTabs-indicator": {
          backgroundColor: theme.palette.custom.fillNeutral,
          borderRadius: theme.borderRadius.sm,
          boxShadow: theme.customShadows.tab,
          height: "100%",
          zIndex: 0,
        },
      }),
    },
    {
      props: { size: "small", styleVariant: "underline" },
      style: ({ theme }) => ({
        "& .MuiTab-root": {
          ...theme.typography.body2,
          fontWeight: 600,
        },
      }),
    },
    {
      props: { size: "small", styleVariant: "boxed" },
      style: ({ theme }) => ({
        minHeight: "32px",
        borderRadius: theme.borderRadius.sm,
        "& .MuiTab-root": {
          minHeight: "24px",
          ...theme.typography.body3,
          fontWeight: 600,
          borderRadius: "8px",
          paddingBottom: theme.spacing(0.25),
          paddingTop: theme.spacing(0.25),
          paddingLeft: theme.spacing(1),
          paddingRight: theme.spacing(1),
        },
        "& .MuiTabs-indicator": {
          borderRadius: "8px",
        },
      }),
    },
  ],
};
